import React from 'react'
import { Grid, InputLabel, TextField } from '@material-ui/core'
import { useStyles } from '../../../pages/ContractPage/components/AddEvents/add-events.styles'
import FileUploadCard from './FileUploadCardInline'

const BuybackSection = ({
  buyback,
  onPathChange,
  onFileChange,
  onDeleteFile,
  inspectionPath,
  consentPath,
  errors = {}
}) => {
  const classes = useStyles()

  return (
    <>
      <Grid item xs={12} className={classes.item}>
        <InputLabel shrink className={classes.inputLabel} style={{ fontSize: 16 }}>
          Информация об автомобиле *
        </InputLabel>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <InputLabel shrink className={classes.inputLabel}>
              Марка *
            </InputLabel>
            <TextField
              placeholder={'Марка'}
              fullWidth
              name="buyback.car.brand"
              value={buyback.car.brand}
              onChange={onPathChange}
              error={Boolean(errors['buyback.car.brand'])}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputLabel shrink className={classes.inputLabel}>
              Модель *
            </InputLabel>
            <TextField
              fullWidth
              name="buyback.car.model"
              value={buyback.car.model}
              onChange={onPathChange}
              placeholder={'Модель'}
              error={Boolean(errors['buyback.car.model'])}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputLabel shrink className={classes.inputLabel}>
              Госномер *
            </InputLabel>
            <TextField
              fullWidth
              name="buyback.car.plate"
              value={buyback.car.plate}
              onChange={onPathChange}
              placeholder={'Госномер'}
              error={Boolean(errors['buyback.car.plate'])}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputLabel shrink className={classes.inputLabel}>
              VIN *
            </InputLabel>
            <TextField
              fullWidth
              name="buyback.car.vin"
              value={buyback.car.vin}
              onChange={onPathChange}
              placeholder={'VIN'}
              error={Boolean(errors['buyback.car.vin'])}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} className={classes.item}>
        <InputLabel shrink className={classes.inputLabel}>
          Акт осмотра/состояния автомобиля (при наличии)
        </InputLabel>
        <FileUploadCard
          label="Нажмите, чтобы загрузить"
          file={buyback?.files?.inspectionReport || null}
          path={inspectionPath}
          onFileChange={onFileChange}
          onDelete={onDeleteFile}
          error={Boolean(errors[consentPath])}
        />
      </Grid>

      <Grid item xs={12} className={classes.item}>
        <InputLabel shrink className={classes.inputLabel}>
          Согласие клиента на обратный выкуп автомобиля *
        </InputLabel>
        <FileUploadCard
          label="Нажмите, чтобы загрузить"
          file={buyback && buyback.files ? buyback.files.buybackConsent || null : null}
          path={consentPath}
          onFileChange={onFileChange}
          onDelete={onDeleteFile}
          error={!!errors[consentPath]}
        />
      </Grid>
    </>
  )
}

export default BuybackSection
